<template>
	<div id="index">
		<HNB></HNB>
		<Poster :posters="posters"></Poster>
		<div class="center1" v-for="(item,i) in center1">
			<Product :imgurl="item.imgurl" :title="item.title" :write="item.write" :know="item.know"
				:svgName="item.svgName" :Subtitle="item.Subtitle" :page="item.page"></Product>
		</div>
		<div class="centerpart">
			<div class="part" v-for="(item,i) in part" @click="topart(item.link)">
				<!-- <div class="part-icon iconfont" v-html="item.icon">{{item.icon}}</div> -->
				<svgIcon class="part-icon" :svg-name="item.icon" size="40"></svgIcon>
				<div class="part-write">{{item.write}}</div>
			</div>
		</div>
		<div class="title"
			style="margin-top:0.1875rem; font-size: 1.2rem;font-weight: 600; width: 90%;margin: 0 auto;text-align: left;padding-bottom: 5rem;">
			部位推荐</div>
		<div class="slider-box">
			<div class="slider-title">品牌新闻</div>
			<div id="slider" class="slider"  style="overflow-y: hidden;">
				<div class="slider-item" @click="toOpen(item.openurl)" id="" v-for="(item,index) in imgSrc">
					<img :src="item.news_home_img" >
					<div id="" class="slider-write">
						{{item.news_title}}
					</div>
				</div>
			</div>
		</div>
		<Bottom :BsTitle="bsTitle"></Bottom>
	</div>
</template>




<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import Bottom from '../components/Bottom.vue'
	import Poster from '../components/Posters.vue'
	import Product from '../components/productView.vue'
	import svgIcon from '../components/SvgIcon.vue'
	// import axios from 'axios'
	import request from '../common/request.js'

	export default {
		name: 'index',
		components: {
			HNB,
			Bottom,
			Poster,
			Product,
			svgIcon
		},

		data() {
			return {
				temp: null,
				sliderWrite: '乐范脚部揉捏按摩器常伴左右',
				imgSrc: [],
				scrollNew: 0,
				scrollOld: 0,
				startPointX: 0,
				changePointX: 0,
				showIndex: 0,
				bsTitle: ['首页'],
				posters: [],
				center1: [{
						imgurl: [this.GLOBAL.imgHost + '/images/index/LF.png'],
						title: '关于乐范',
						write: '让按摩变得简单',
						know: '详情了解',
						active: 'about',
						page: 'aboutus',
					},
					{
						imgurl: [this.GLOBAL.imgHost + '/images/index/pruduct.png', this.GLOBAL.imgHost +
							'/images/index/kaoyao.jpg',
							this.GLOBAL.imgHost + '/images/index/KaoZhen.jpg'
						],
						title: '销量领先产品',
						write: '全网人气销量排行榜',
						Subtitle: '网红',
						know: '查看更多',
						svgName: 'CGD',
						page: 'salesVolume',
						active: 'product'
					},
					{
						imgurl: [this.GLOBAL.imgHost + '/images/index/DeDao.png'],
						title: '跨界联名产品',
						write: '熊本熊 | 迪士尼 | 得到 <br/> 吴晓波频道 | 日行千里……',
						Subtitle: '新品',
						know: '查看详情',
						page: 'jointly',
						active: 'science'
					},
				],
				part: [{
						icon: 'body',
						write: '全身',
						link: 'quanshen'
					},
					{
						icon: 'head',
						write: '头部',
						link: 'head'
					},
					{
						icon: 'shouder',
						write: '肩部',
						link: 'jianbu'
					},
					{
						icon: 'waist',
						write: '腰部',
						link: 'yaobu'
					},
					{
						icon: 'leg',
						write: '腿部',
						link: 'tuibu'
					},
					{
						icon: 'foot',
						write: '脚部',
						link: 'foot'
					},
				]
			}
		},
		async mounted() {
			await this.listDate();
			await this.getNewsList()
		},
		methods: {
			async listDate() {
				// 获取轮播图列表
				// request.uniRequest('/swiper/getSwiperList').then(res => {
			
				// 	this.posters = res.data.filter(item => item.web_type == 1)
				// 	console.log('swiper---------', this.posters);
				// }).catch(e => {})
				
				let res = await this.$Cloud
					.table(`lf_func_lefan_swiper`)
					.where({
						link_table_array: ['swiper']
					})
					.get({
						page: 0,
						pageSize: 1000
					})
				
				const {
					code,
					data
				} = res
							
				if (code == 200) {
					this.posters = data.filter(item => {
						return item.web_type == 2 && item.is_check == 2
					})
					console.log('获取轮播图123', this.posters)
				}
				
			},
			async getNewsList() {
				let res = await this.$Cloud.table(`lf_func_lefan_news`).get({ page: 0, pageSize: 1000 })
				
				const {data,code}  = res
				if(code == 200) {
					this.imgSrc = data.filter(item => item.is_check == 2)
				}
				console.log('获取新闻列表====>>>>',res)
				// 获取新闻列表
				// request.uniRequest('/news/getNewsList')
				// 	.then(res => {
				// 		this.imgSrc = res.data
				// 	}).catch(e => {})
			},
			imgScroll(e) {
				// console.log('test----scroll---e',e)
				// let that = this;
				// let wid = e.target.scrollWidth / (that.imgSrc.length + 1);
				// that.scrollNew = e.target.scrollLeft;
				// clearTimeout(that.temp);
				// console.log(e.target.scrollLeft, wid);
				// let move_thing = 0;

				// for (var i = 0; i < that.imgSrc.length; i++) {
				// 	console.log('11',i,(e.target.scrollLeft / wid),( i === 0 ? 0.5 : i *1.5));
				// 	if((e.target.scrollLeft / wid) < ( i === 0 ? 0.5 : i *1.5) && (e.target.scrollLeft / wid) > ((i-1) === 0 ? 0.5 : (i-1) *1.5)){
				// 		move_thing =wid * (i * 1.2);
				// 		that.sliderWrite = that.imgSrc[i].news_title;
				// 	}
				// }

				// if (e.target.scrollLeft / wid < 0.5) {
				// 	move_thing = 0;
				// 	that.sliderWrite = '乐范脚部揉捏按摩器常伴左右';
				// } else if (e.target.scrollLeft / wid < 1.5) {
				// 	move_thing = wid * 1.20;
				// 	that.sliderWrite = '乐范双色颈枕让你的颈椎不再无处安放';
				// } else if (e.target.scrollLeft / wid < 3.0) {
				// 	move_thing = wid * 2.40;
				// 	that.sliderWrite = '乐范健康科技销售额逆势增长236%';
				// } else {
				// 	move_thing = wid * 3.6;
				// 	that.sliderWrite = '小米眼仪测评：充电2小时按摩100分钟';
				// }

				// that.temp = setTimeout(function() {
				// 	document.getElementById('slider').scrollLeft = move_thing;
				// }, 200);

			},
			tohref() {
				this.$router.push({
					path: '/partrecommended'
				})
			},
			topart(e) {
				let routeUrl = this.$router.resolve({
					path: "/partrecommended",
					query: {
						partname: e
					}
				});
				window.open(routeUrl.href, '_self');
			},
			toOpen(e) {
				window.open(e, '_self');
				console.log('走了')
				// let routeUrl
				// let startTime
				// let endTime
				// let timestamp
				// timestamp = new Date().getTime()
				// if(item.effect_time) {
				// 	startTime = new Date(item.effect_time[0]).getTime()
				// 	endTime = new Date(item.effect_time[1]).getTime()
				// }
				// if (startTime && endTime && timestamp <= endTime && timestamp >= startTime) {
				// 	routeUrl = item.openurl
				// 	window.open(routeUrl, '_blank');
				// } else {
				// 	routeUrl = this.$router.resolve({
				// 		path: "/news",
				// 		query: {
				// 			id: item._id
				// 		}
				// 	});
				// 	window.open(routeUrl.href, '_blank');
				// }
			}

		},

	}
</script>

<style>
	@import url("../common/animate.min.css");

	@font-face {
		font-family: 'iconfont';
		/* project id 1631181 */
		src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot');
		src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot?#iefix') format('embedded-opentype'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff2') format('woff2'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff') format('woff'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.ttf') format('truetype'),
			url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: 'iconfont';
	}

	* {
		padding: 0;
		margin: 0;
		/* overflow-x: hidden; */
	}

	#index {
		max-width: 33.75rem;
		/* height: 100%; */
		margin: 0 auto;
	}

	.center1 {
		/* margin-top: 10%; */
	}

	.centerpart {
		width: 90%;
		max-width: 350px;
		clear: both;
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		flex-direction: row;
		align-items: center;
		margin: 0 auto;
		margin-top: 20%;
		margin-bottom: 20%;
	}

	.centerpart .part-icon {
		color: #00C785;
		font-size: 2.5rem;
		margin-top: 15%;
	}

	.centerpart .part-write {

		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		margin-top: 1px;
		/* line-height:81px; */
		opacity: 0.7;
	}

	.centerpart .part {
		width: 6.5rem;
		height: 6.5rem;
		background-color: #F0F0F0;
		margin-bottom: 0.625rem;
		/* line-height: 6rem; */
	}

	.centerpart .title {
		width: 100%;
		font-size: 1rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 600;
		color: rgba(29, 29, 29, 1);
		text-align: left;
		margin-top: 3%;
	}

	.slider-box {
		width: 100%;
		/* height:26rem; */
		display: flex;
		flex-direction: column;
		align-items: center;
		/* overflow-x: hidden; */
		/* overflow-y: hidden; */
		background: rgba(143, 174, 154, 1);
		/* padding-top: 30%; */
	}

	.slider-box .slider-title {
		width: 30%;
		height: 20%;
		font-size: 1.125rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 600;
		color: rgba(255, 255, 255, 1);
		line-height: 70px;
		left: 35%;
		margin-top: 40px;
		margin-bottom: 20px;
	}

	.slider {
		width: 100%;
		/* height: 16rem; */
		display: flex;
		flex-direction: row;
		margin: 0 auto;
		overflow: scroll;
		padding: 30px auto;
		overflow-x: ;
		/* 		padding: 0 1.875rem; */
		/* padding-left: 30px;
		padding-right: 30px; */
	}

	.slider .slider-item {
		display: flex;
		flex-direction: column;
		width: 100vw;
		padding: 0 0.94rem;
	}

	.slider img {
		/* width: 80%; */ 
		height: auto;
		object-fit: contain;
		width: 80vw
		/* overflow-x: scroll; */
		/* overflow: hidden; */
		/* padding-right: 1.875rem; */
		/* padding-left: 1.875rem; */
	}

	::-webkit-scrollbar {
		/*隐藏滚轮*/
		display: none;
	}

	.slider-box .slider-write {
		width: 100%;
		height: 3.5rem;
		font-size: 0.85rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		margin-top: 40px;
		margin-bottom: 30px;
	}
</style>
